import { Update } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { OrderHistoryItem } from '../../models';
import { PaginatedResponse } from '~shared/models';
import { ErrorResponse } from '~shared/modules/error-handler';
import {
  clearOrdersList,
  loadOrder,
  loadOrdersList,
  loadOrdersListSuccess,
  loadOrderSuccess,
  orderHistoryFailure,
} from './orders-history-list.actions';
import { orderHistoryAdapter } from './orders-history-list.adapter';
import { initialOrdersHistoryState, OrdersHistoryState } from './orders-history-list.state';

const reducer = createReducer(
  initialOrdersHistoryState,
  on(
    loadOrdersList,
    loadOrder,
    handleRequestAction,
  ),
  on(loadOrdersListSuccess, handleLoadOrdersListSuccess),
  on(orderHistoryFailure, handleFailureAction),
  on(clearOrdersList, () => initialOrdersHistoryState),
  on(loadOrderSuccess, handleLoadOrderSuccess),
);

function handleLoadOrderSuccess(
  state: OrdersHistoryState,
  { order }: { order: Update<OrderHistoryItem> }): OrdersHistoryState {
  return orderHistoryAdapter.updateOne(order, {
    ...state,
    loading: false,
  });
}

function handleLoadOrdersListSuccess(
  state: OrdersHistoryState,
  { items, totalCount }: PaginatedResponse<OrderHistoryItem>): OrdersHistoryState {
  return orderHistoryAdapter.addMany(items, {
    ...state,
    error: null,
    loading: false,
    totalCount,
  });
}

function handleRequestAction(state: OrdersHistoryState): OrdersHistoryState {
  return {
    ...state,
    error: null,
    loading: true,
  };
}

function handleFailureAction(state: OrdersHistoryState, { error }: { error: ErrorResponse }): OrdersHistoryState {
  return {
    ...state,
    error,
    loading: false,
  };
}


export function ordersHistoryListReducer(state: OrdersHistoryState, action: Action) {
  return reducer(state, action);
}
